import React from "react";
import QuickAnswerLink from "../QuickAnswerLink";

export const quickAnswerLinkProcessor = ({ slugPubtype, slugTitle }) => {
  const linkBase = `/${slugPubtype}/${slugTitle}#`;

  return {
    replaceChildren: true,
    shouldProcessNode: (node) =>
      node.attribs && node.attribs["class"] === "mapping-link",
    processNode: (node) => {
      return (
        <QuickAnswerLink linkUrl={`${linkBase}${node.attribs["data-href"]}`} />
      );
    },
  };
};
